import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=f6c772ba&scoped=true"
import script from "./Lottery.vue?vue&type=script&lang=js"
export * from "./Lottery.vue?vue&type=script&lang=js"
import style0 from "./Lottery.vue?vue&type=style&index=0&id=f6c772ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c772ba",
  null
  
)

export default component.exports